import api from './api';

/**
 * Invoice API service. Talks to the backend `/api/invoices` endpoints (scoped
 * server-side by the authenticated user). The shared `api` instance already
 * unwraps to the response body, so each call resolves to
 * `{ success, message, data, pagination? }`.
 */
const invoiceService = {
    create: (data) => api.post('/api/invoices', data),

    list: (params = {}) => api.get('/api/invoices', { params }),

    get: (id) => api.get(`/api/invoices/${id}`),

    update: (id, data) => api.put(`/api/invoices/${id}`, data),

    remove: (id) => api.delete(`/api/invoices/${id}`),
};

export default invoiceService;
